export const PageLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full">
      <div className="px-[26px] py-[34px] w-full h-full md:py-[78px] md:px-[119px] max-w-[1200px]">
        {children}
      </div>
    </div>
  )
}
